import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AuthContext } from '../../context/auth'
import Navbar from '../Navbar/navbar'
import { Footer } from '../Footer'
import SignIn from "../../pages/SignIn"
import SignUp from "../../pages/SignUp"
import CompleteModal from "../modals/completeModal"
import RestoreModal from "../modals/restorePasswordModal"
import ChangePasswordRestoreModal from "../modals/changePasswordRestoreModal"
import ChangePasswordModal from "../modals/changePasswordModal"
import ChangeEmailModal from "../modals/changeEmailModal"
import LogOutModal from "../modals/LogOutModal"
import DeleteProfileModal from "../modals/DeleteProfileModal"
import TeamModal from '../modals/teamModal'
import ShippingAddressModal from '../modals/shippingAddressModal'
import BillingAddressModal from '../modals/billingAddressModal'
import OrderCompleteModal from '../modals/orderCompleteModal'
import ThankYouModal from '../modals/ThankYouModal'
import PopupModal from '../modals/PopupModal'
import UpcomingPurchaseModal from '../modals/UpcomingPurchaseModal'
import BulkOrderFormModal from '../modals/bulkOrderFormModal'
import CartModal from '../modals/CartModal'
import Notification from '../Notification'
import Helmet from "../Helmet"
import Cookies from 'js-cookie'
import { getLocalStorage } from '../../helpers/localStorage'
import { isBot } from '../../utils/botCheck'


const Index = ({ children, meta }) => {
  const { user, signInModal, setSignInModal, signUpModal, setSignUpModal, completeModal, setCompleteModal, restoreModal, setRestoreModal, changePasswordModal, setChangePasswordModal, changePasswordRestoreModal, setChangePasswordRestoreModal, notification, setNotification, teamModal, setTeamModal, changeEmailModal, setChangeEmailModal, logOutModal, setLogOutModal, deleteProfileModal, setDeleteProfileModal, shippingAddressModal, setShippingAddressModal, billingAddressModal, setBillingAddressModal, completeOrderModal, setCompleteOrderModal, tempDisable, setTempDisable, openItemPreviewModal, setOpenItemPreviewModal, setSelectedProduct, setSelectedProtein, setMapViewActive, openPopupModal, setOpenPopupModal, upcomingPurchaseModal, setUpcomingPurchaseModal, bulkOrderModal, setBulkOrderModal } = useContext(AuthContext)
  const location = useLocation()
  useEffect(() => {
    if (signInModal || signUpModal || completeModal || restoreModal || changePasswordModal || changePasswordRestoreModal || teamModal || changeEmailModal || logOutModal || deleteProfileModal || shippingAddressModal || billingAddressModal || completeOrderModal || openItemPreviewModal || upcomingPurchaseModal || bulkOrderModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [signInModal, signUpModal, completeModal, restoreModal, changePasswordModal, changePasswordRestoreModal, teamModal, changeEmailModal, logOutModal, deleteProfileModal, shippingAddressModal, billingAddressModal, completeOrderModal, tempDisable, openItemPreviewModal, upcomingPurchaseModal, bulkOrderModal])


  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(null)
      }, 2500)
    }
  }, [notification])


  useEffect(() => {
    const handleBackButton = () => {
      setSignInModal(false)
      setSignUpModal(false)
      setCompleteModal(false)
      setRestoreModal(false)
      setChangePasswordModal(false)
      setChangePasswordRestoreModal(false)
      setTeamModal(false)
      setChangeEmailModal(false)
      setLogOutModal(false)
      setDeleteProfileModal(false)
      setShippingAddressModal(false)
      setBillingAddressModal(false)
      setCompleteOrderModal(false)
      setTempDisable(true)
      setOpenItemPreviewModal(false)
      setMapViewActive(false)
      setSelectedProduct(null)
      setSelectedProtein(null)
      setOpenPopupModal(false)
      setUpcomingPurchaseModal(false)
      setBulkOrderModal(false)
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", () => handleBackButton);
    }

  }, [])

  useEffect(() => {
    if (location.pathname === '/login' && !getLocalStorage('identifyntoken') && !user) {
      setSignInModal(true)
    }
    if (location.pathname === '/reset'){
      setRestoreModal(true)
    }
    if((location.pathname === '/product/pathways/ssb' || location.pathname === '/product/pathways/dsb-hr' || location.pathname === '/product/pathways/dsb-nh')) {
    }else{
      setMapViewActive(false)
      setSelectedProduct(null)
      setSelectedProtein(null)
    }
  }, [location, user])

useEffect(() => {
  const popupSeen = Cookies.get('cartPopupSeen')
  if(!popupSeen && !isBot()) {
    // setTimeout(() => {
    //   setCartModal(true)
    // }, 5000)
  }
}, [])


  return (
    <>
      {<Helmet meta={meta} />}
      {notification && <Notification message={notification.message} subMessage={notification.subMessage} type={notification.type} onClick={() => setNotification(null)} />}
      <Navbar />
      <main>
        {children}
      </main>
      {/* <Footer/> */}
      {/* {openCartModal && <CartModal />} */}
      {signInModal && <SignIn />}
      {signUpModal && <SignUp />}
      {completeModal && <CompleteModal />}
      {restoreModal && <RestoreModal />}
      {changePasswordRestoreModal && <ChangePasswordRestoreModal />}
      {changePasswordModal && <ChangePasswordModal />}
      {teamModal && <TeamModal />}
      {changeEmailModal && <ChangeEmailModal />}
      {logOutModal && <LogOutModal />}
      {deleteProfileModal && <DeleteProfileModal />}
      {shippingAddressModal && <ShippingAddressModal />}
      {billingAddressModal && <BillingAddressModal />}
      {completeOrderModal && <OrderCompleteModal />}
      {/* {!tempDisable && <ThankYouModal />} */}
      { upcomingPurchaseModal && <UpcomingPurchaseModal /> }
      {bulkOrderModal && <BulkOrderFormModal />}
      {openPopupModal && <PopupModal />}
    </>
  )
}

export default Index